var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFfr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 17,
    viewBox: "0 0 30 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.707H6.02748V9.37755H9.88827V8.129H6.02748V5.95559H10.1529V4.70703H4.5V12.707Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8729 12.707H13.4004V9.37755H17.2611V8.129H13.4004V5.95559H17.5257V4.70703H11.8729V12.707Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1444 9.40067C23.5395 9.40067 23.8041 9.83998 23.8041 10.7995V10.9382C23.8041 11.7475 23.8162 12.3602 23.9605 12.707H25.4519C25.3316 12.3486 25.3316 11.7013 25.3316 11.1579V10.788C25.3316 9.36599 24.7182 8.92668 24.2131 8.7764C24.8866 8.54518 25.5 7.94403 25.5 6.892C25.5 5.64345 24.5498 4.70703 22.7698 4.70703H19.2458V12.707H20.7853V9.40067H22.1444ZM20.7853 5.9209H22.4571C23.4313 5.9209 23.9124 6.32553 23.9124 7.04229C23.9124 7.79374 23.4794 8.1868 22.3969 8.1868H20.7853V5.9209Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfr);
export default __webpack_public_path__ + "static/media/ffr.1958cacc.svg";
export { ForwardRef as ReactComponent };